module.exports = __webpack_public_path__ + "img/Tablet - 20.904caff9.png";